// extracted by mini-css-extract-plugin
export default {"products":"Ev-z","card":"Fv-z","oosMessaging":"Gv-z"};